// Convierte el dashboard de BD (visuals_builder) al `config` que VisualRenderer
// espera. CLAVE: render_config se SPREADEA dentro del block, porque los widgets
// base (KpiCard, EChartsWidget, etc.) leen block.metric / block.source directamente
// (no anidado bajo block.render_config).
//
// Entrada (de getDefaultVisualDashboard):
//   { id, name, theme, engine, dataset, date_cutoff, columns?,
//     widgets: [{ id, widget_type, title, render_config, data_sql, data, size, position, status }] }
//
// Salida (lo que consume VisualRenderer / VisualsPage):
//   { id, title, theme, dataset, engine, dateCutoff, filters,
//     layout: [{ type, span, title, ...render_config, _widgetId }] }

const DEFAULT_FILTERS = [
  { key: 'retailer', label: 'Retailer', field: 'retailer' },
  { key: 'departamento', label: 'Departamento', field: 'departamento' },
  { key: 'subdepartamento', label: 'Subdepartamento', field: 'subdepartamento' },
  { key: 'clase', label: 'Clase', field: 'clase' },
  { key: 'marca', label: 'Marca', field: 'marca' },
];

export function mapWidgetToBlock(w) {
  const rc = w.render_config || {};
  return {
    type: w.widget_type,        // 'kpi' | 'kpiPair' | 'echarts' | 'lineChart' | ...
    span: w.size || 12,
    ...rc,                      // metric/label/format  ó  source/chart/encoding/option
    title: w.title || rc.title, // título explícito del widget gana sobre rc.title
    _widgetId: w.id,            // referencia para el builder (edit/delete)
    // data materializada del data_sql (Fase 4); undefined si aún no se corrió
    // (evita pasar {} como referencia nueva en cada render).
    _widgetData: w.data && Object.keys(w.data).length ? w.data : undefined,
  };
}

export function mapDashboardToConfig(dashboard) {
  if (!dashboard) return null;
  const widgets = [...(dashboard.widgets || [])].sort(
    (a, b) => (a.position ?? 0) - (b.position ?? 0)
  );
  return {
    id: dashboard.id,
    title: dashboard.name || 'Visuales',
    theme: dashboard.theme || {},
    dataset: dashboard.dataset || 'pricing-analytics',
    engine: dashboard.engine || 'athena',
    dateCutoff: dashboard.date_cutoff || null,
    filters: dashboard.filters || DEFAULT_FILTERS,
    layout: widgets.map(mapWidgetToBlock),
  };
}

export default mapDashboardToConfig;
